"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filmStencilDefinition = void 0;
const properties_1 = require("../properties");
const content_classification_terms_property_1 = require("../properties/content-classification-terms.property");
const cta_container_property_1 = require("../properties/cta-container.property");
const description_property_1 = require("../properties/description.property");
const epg_title_property_1 = require("../properties/epg-title.property");
const logos_property_1 = require("../properties/logos.property");
const mediabase_essence_property_1 = require("../properties/mediabase-essence.property");
const no_embedding_property_1 = require("../properties/no-embedding.property");
const playability_start_date_property_1 = require("../properties/playability-start-date.property");
const social_media_image_property_1 = require("../properties/social-media-image.property");
const sponsored_by_property_1 = require("../properties/sponsored-by.property");
const rbtvContentAreas = [
    {
        name: 'main',
        items: [
            'header-media',
            'title',
            'subheading',
            'teaser',
            'description',
            'epg-description',
            'mediabase-essence',
            'video-markers',
        ],
    },
    {
        name: 'info',
        subAreas: [
            {
                name: 'General',
                items: [
                    'seo-title',
                    'social-title',
                    'featured-title',
                    'epg-title',
                    'uri-title',
                    'url',
                    'featured-media',
                    'social-media-image',
                    'featured-video',
                    'geolocation',
                    'logos',
                    'playability-start-date',
                ],
            },
            {
                name: 'CTA',
                items: ['cta-container'],
            },
            {
                name: 'Settings',
                items: [
                    'search-terms',
                    'content-classification-terms',
                    'no-embedding',
                    'standalone',
                    'no-monetization',
                    'sponsored-by',
                ],
            },
            {
                name: 'Custom Properties',
                items: ['properties-container'],
            },
        ],
    },
    {
        name: 'tagging',
        items: [
            'disciplines',
            'content-categories',
            'tag-events',
            'tag-event-series',
            'tag-persons',
            'tag-teams',
            'related-content',
        ],
    },
];
exports.filmStencilDefinition = {
    view: {
        label: 'Film',
        group: 'Moving images',
        titleItems: ['title'],
        imageItems: ['featured-media'],
        contentAreas: [
            {
                name: 'main',
                items: [
                    'header-media',
                    'title',
                    'subheading',
                    'teaser',
                    'description',
                    'mediabase-essence',
                    'video-markers',
                ],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'epg-title',
                            'uri-title',
                            'url',
                            'featured-media',
                            'social-media-image',
                            'featured-video',
                            'geolocation',
                            'logos',
                            'playability-start-date',
                        ],
                    },
                    {
                        name: 'CTA',
                        items: ['cta-container'],
                    },
                    {
                        name: 'Settings',
                        items: [
                            'search-terms',
                            'content-classification-terms',
                            'no-embedding',
                            'standalone',
                            'no-monetization',
                            'sponsored-by',
                        ],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: [
                    'disciplines',
                    'content-categories',
                    'tag-events',
                    'tag-event-series',
                    'tag-persons',
                    'tag-teams',
                    'related-content',
                ],
            },
        ],
        previewConfiguration: {
            hasPagePreview: true,
            hasFeatureCardPreview: true,
        },
    },
    content: {
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'header-media': {
            ...properties_1.headerMediaPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: [
                        'image',
                        'video',
                        'episode-video',
                        'film',
                        'recap-video',
                        'trailer-video',
                        'video-channel',
                    ],
                },
            ],
        },
        title: properties_1.titlePropertyDefinition,
        teaser: properties_1.teaserPropertyDefinition,
        description: description_property_1.descriptionPropertyDefinition,
        'cta-container': cta_container_property_1.ctaContainerPropertyDefinition,
        'mediabase-essence': {
            ...mediabase_essence_property_1.mediabaseEssencePropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: false,
                },
                mediabase_essence_property_1.mediabaseEssencePropertyDefinition.constraints[1],
            ],
        },
        'video-markers': properties_1.videoMarkersPropertyDefinition,
        'seo-title': properties_1.seoTitlePropertyDefinition,
        'social-title': properties_1.socialTitlePropertyDefinition,
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'epg-description': properties_1.epgDescriptionPropertyDefinition,
        'epg-title': epg_title_property_1.epgTitlePropertyDefinition,
        'uri-title': properties_1.uriTitlePropertyDefinition,
        'featured-media': properties_1.featuredMediaPropertyDefinition,
        'featured-video': {
            ...properties_1.featuredVideoPropertyDefinition,
            view: {
                label: 'Featured video',
                style: '',
                hint: 'Used to represent the content piece on collection pages.',
                hintAdditional: 'If there is a preview clip available it will be automatically embedded here after publishing. Please notice it may take a few minutes upon publishing before the preview clip will show.',
            },
        },
        geolocation: properties_1.geolocationPropertyDefinition,
        'content-classification-terms': content_classification_terms_property_1.contentClassificationTermsPropertyDefinition,
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        'social-media-image': social_media_image_property_1.socialMediaImagePropertyDefinition,
        'no-monetization': properties_1.noMonetizationPropertyDefinition,
        disciplines: {
            ...properties_1.disciplinesPropertyDefinition,
            constraints: [
                {
                    name: 'required',
                    argument: true,
                },
                {
                    name: 'stencils',
                    argument: ['discipline'],
                },
            ],
        },
        'content-categories': properties_1.contentCategoriesPropertyDefinition,
        subheading: properties_1.subheadingPropertyDefinition,
        'tag-events': properties_1.tagEventsPropertyDefinition,
        'tag-event-series': properties_1.tagEventSeriesPropertyDefinition,
        'tag-persons': properties_1.tagPersonsPropertyDefinition,
        'tag-teams': properties_1.tagTeamsPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        url: properties_1.urlPropertyDefinition,
        'no-embedding': no_embedding_property_1.noEmbeddingPropertyDefinition,
        'search-terms': properties_1.searchTermsPropertyDefinition,
        logos: logos_property_1.logosPropertyDefinition,
        'sponsored-by': sponsored_by_property_1.sponsoredByPropertyDefinition,
        'playability-start-date': playability_start_date_property_1.playabilityStartDatePropertyDefinition,
    },
    localizations: [],
    roles: [],
    spaces: [
        'brand-building-events',
        'media-partnerships',
        'racing-bulls',
        'rbtv',
        'rbtv_temporary',
        'redbull-racing',
    ],
    overwrites: [
        {
            condition: 'space',
            argument: 'rbtv',
            contentAreas: rbtvContentAreas,
        },
    ],
    name: 'film',
};
const isFilmStencil = (stencil) => {
    return stencil.name === exports.filmStencilDefinition.name;
};
//# sourceMappingURL=data:application/json;base64,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